import React from 'react';
import { useSelector } from 'react-redux';
import { Button, IcoClose, Input } from '../../component';

interface IDefineRadiusProps {
  closeBtnAction: () => void;
  inputValue: number;
  inputAction: React.Dispatch<React.SetStateAction<number>>;
  applyBtnAction: () => void;
}

const DefineRadius = ({
  closeBtnAction,
  inputValue,
  inputAction,
  applyBtnAction,
}: IDefineRadiusProps): JSX.Element => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  return (
    <div className="select-box select-radius-size">
      <div className="define-radius-title-container">
        <h1 className="define-radius-title">{nls.defineInfluenceRadius}</h1>
        <button
          onClick={() => {
            closeBtnAction();
          }}
        >
          <IcoClose cy="IconCloseInfluenceRadius" />
        </button>
      </div>
      <Input
        label={nls.defineRadius}
        name="influenceRadius"
        cy="InfluenceRadius"
        value={inputValue}
        type="number"
        labelClass="label-color"
        action={(e) => inputAction(Number(e.value) >= 0 ? Number(e.value) : 0)}
        right="m"
      />
      <Button
        cy="DefineInfluenceRadius"
        color="primary"
        className="define-radius-apply-btn btn"
        size="block"
        onClick={() => {
          applyBtnAction();
        }}
      >
        {nls.define}
      </Button>
    </div>
  );
};

export default DefineRadius;
